import { WorkerActionData } from '@/hooks/useSecWorker';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { hostsSliceActions } from '../../../modules/host/slice';
import { Dealer } from '../../host/Dealer';
import { CMDScAnchorLogin, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScAnchorLoginHandler extends AbstractHandler {
    _command: CMDScAnchorLogin;
    _registWorkerAction: (item: WorkerActionData) => void;
    constructor(
        command: ICommand,
        registWorkerAction: (item: WorkerActionData) => void
    ) {
        super();
        this._command = command as CMDScAnchorLogin;
        this._registWorkerAction = registWorkerAction;
    }
    commandDelay() {
        return 10000;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const hostId = this._command.HostID;
        const dealer = this._command.Anchor.map(
            a =>
                ({
                    DealerId: a.DealerID,
                    DealerName: a.DealerName,
                }) as Dealer
        );
        dispatch(hostsSliceActions.dealerLogin({ hostId, dealer }));

        this._registWorkerAction({
            key: `dealer-${hostId.toString()}`,
            time: 90,
            callbackFunc: () => {
                dispatch(hostsSliceActions.dealerImageRefresh({ hostId }));
            },
        });
    }
}
